import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import File_upload from './../Pop_up/File_upload'

const Attachment_pop = (props) => {
  const {
    buttonLabel,
    className
  } = props;

  const [modal, setModal] = useState(false);
  const [nestedModal, setNestedModal] = useState(false);
  const [closeAll, setCloseAll] = useState(false);

  const toggle = () => setModal(!modal);
  const toggleNested = () => {
    setNestedModal(!nestedModal);
    setCloseAll(false);
  }
  const toggleAll = () => {
    setNestedModal(!nestedModal);
    setCloseAll(true);
  }


  return (


      
    <>

    <i onClick={toggle} className="fa fa-upload" aria-hidden="true" title="Upload Document"></i>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Attachment </ModalHeader>
        <ModalBody>
        <div className="row">
<div className="box_attachment">

<div className="box_attach_type">
<div className="form-inner-box full_with">					
<div className="floating-label">      
<select className="floating-select">
<option value=""></option>
<option value="1">Contract</option>
<option value="2">Offer Letter</option>
<option value="3">Resume</option>
<option value="4">Cover Letter</option>
<option value="4">Other</option>
</select>

<label>Attachment Type
</label>
</div>
</div>
</div>

<File_upload/>


	</div>
</div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>          
          <Button color="primary" onClick={toggle}>Upload</Button>{' '}
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Attachment_pop;